
import { useTranslations } from "@/i18n";

interface DeckProgressProps {
  count: number;
  current: number;
  titles: string[];
  onSelect: (index: number) => void;
}

export function DeckProgress({
  count,
  current,
  titles,
  onSelect,
}: DeckProgressProps) {
  const t = useTranslations("deckViewer");

  return (
    <div className="pointer-events-auto flex items-center gap-3 rounded-full bg-black/50 px-4 py-2 backdrop-blur-sm">
      <div className="flex items-center gap-1.5">
        {Array.from({ length: count }, (_, index) => (
          <button
            key={index}
            type="button"
            aria-label={t("goToSlide", { title: titles[index] ?? String(index + 1) })}
            aria-current={index === current ? "true" : undefined}
            onClick={() => onSelect(index)}
            className={`h-1.5 rounded-full transition-all duration-300 ${
              index === current
                ? "w-6 bg-landing-accent"
                : "w-1.5 bg-white/30 hover:bg-white/60"
            }`}
          />
        ))}
      </div>
      <span className="font-mono text-[11px] tabular-nums text-white/70">
        {current + 1} / {count}
      </span>
    </div>
  );
}
